import QuickQuoteLog from "./quickQuoteLog"

export default QuickQuoteLog
